import { ICenterFiveStarDetail, ICenterFiveStarSurvey } from '@nkr/models/index';
import _ from 'lodash';


interface IProps {
    detail: ICenterFiveStarDetail,
    aspectName: string
}

const CenterFiveStarSurveyRow = (props: IProps) => {
    let rowDetail = props.detail;

    return (
        <tr>
            <td style={{ textAlign: "left" }}>{props.aspectName}</td>

            {rowDetail.hasBeenVoted ?
                <>
                    <td style={{ backgroundColor: "" }}> {rowDetail.countOf1Star} </td>
                    <td style={{ backgroundColor: "" }}> {rowDetail.countOf2Star} </td>
                    <td style={{ backgroundColor: "" }}> {rowDetail.countOf3Star} </td>
                    <td style={{ backgroundColor: "" }}> {rowDetail.countOf4Star} </td>
                    <td style={{ backgroundColor: "" }}> {rowDetail.countOf5Star} </td>
                </>
                :
                <td colSpan={5} style={{ backgroundColor: "#cccccc" }}>--</td>
            }

            {rowDetail.networkAverage != 0 ?
                <>
                    <td> {rowDetail.hasBeenVoted ? rowDetail.centerAverage.toFixed(1) : "--"} </td>
                    <td> {rowDetail.centerAverageN} </td>
                    <td> {rowDetail.networkAverage.toFixed(1)} </td>
                    <td> {rowDetail.networkAverageN} </td>
                </>
                :
                <td colSpan={4} style={{ backgroundColor: "#cccccc" }}>--</td>
            }

            {rowDetail.networkDiff != null ?
                <td style={{ backgroundColor: rowDetail.networkDiff < 0 ? "pink" : "lime" }}> {rowDetail.networkDiff} </td>
                :
                <td style={{ backgroundColor: "#cccccc" }}>--</td>
            }
        </tr>
    )
}

export default CenterFiveStarSurveyRow;